import axios from "axios";
import API_URL from "./Config";

let refreshPromise = null;

const refreshToken = async () => {
  if (refreshPromise) return refreshPromise;

  refreshPromise = (async () => {
    try {
      const storedRefreshToken = localStorage.getItem("refresh_token");
      if (!storedRefreshToken) {
        console.warn("No refresh token found in localStorage");
        return null;
      }

      console.log("Attempting to refresh token...");

      // Call your backend refresh API - ADD /api/ prefix
      const response = await axios.post(
        `${API_URL}/refresh`,  // Changed from /refresh to /api/refresh
        { refresh_token: storedRefreshToken },
        {
          headers: {
            "Content-Type": "application/json",
          }
        }
      );

      console.log("Refresh response received");

      const newAccess =
        response.data.access_token ||
        response.data.authKey ||
        response.data.token;

      const newRefresh =
        response.data.refresh_token ||
        response.data.new_refresh ||
        storedRefreshToken;

      if (!newAccess) {
        console.error("No access token in refresh response");
        return null;
      }

      localStorage.setItem("authKey", newAccess);
      localStorage.setItem("refresh_token", newRefresh);


      return newAccess;
    } catch (e) {
      console.error("Refresh failed:", e.response?.data || e.message);
      // Clear tokens if refresh fails
      localStorage.removeItem("authKey");
      localStorage.removeItem("refresh_token");
      return null;
    } finally {
      refreshPromise = null;
    }
  })();

  return refreshPromise;
};

export default refreshToken;
